import { render, staticRenderFns } from "./ElementEditCard.vue?vue&type=template&id=3c59ea4e"
import script from "./ElementEditCard.vue?vue&type=script&lang=js"
export * from "./ElementEditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports